export const GET_COVID_CONTENT = "GET_COVID_CONTENT";
export const GET_COVID_CONTENT_FAIL = "GET_COVID_CONTENT_FAIL";
export const GET_COVID_CONTENT_SUCCESS = "GET_COVID_CONTENT_SUCCESS";

export function getCovidContent() {
  return {
    type: GET_COVID_CONTENT
  }
}
